import React, { type FC } from 'react';
import { Tooltip } from './tooltip/Tooltip';

interface TruncateTextProps {
  text: string | undefined;
  truncateEnd?: boolean;
  maxLength?: number;
  separator?: string;
  hasTooltip?: boolean;
}

export const TruncateText: FC<TruncateTextProps> = ({
  text,
  truncateEnd = false,
  maxLength = 30,
  separator = '...',
  hasTooltip = true,
}) => {
  if (!text) return null;
  if (text.length <= maxLength + separator.length) return <div style={{ wordBreak: 'break-word' }}>{text}</div>;

  const frontChars = Math.ceil(maxLength / 2);
  const backChars = Math.floor(maxLength / 2);

  const Wrapper = hasTooltip ? Tooltip : React.Fragment;

  return (
    <div style={{ wordBreak: 'break-word' }}>
      <Wrapper {...(hasTooltip ? { title: text } : {})}>
        {truncateEnd
          ? `${text.substring(0, maxLength)}${separator}`
          : `${text.substring(0, frontChars)}${separator}${text.substring(text.length - backChars)}`}
      </Wrapper>
    </div>
  );
};
